import { render, staticRenderFns } from "./dragableTable.vue?vue&type=template&id=cef82eea"
import script from "./dragableTable.vue?vue&type=script&lang=js"
export * from "./dragableTable.vue?vue&type=script&lang=js"
import style0 from "./dragableTable.vue?vue&type=style&index=0&id=cef82eea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports